@if (autoHide) {
  <div class="hover-trigger" (mouseenter)="isHovered = true"></div>
}
<nz-header
  [style.backgroundColor]="serverInfo()?.test ? '#eee990' : 'white'"
  (mouseenter)="isHovered = true"
  (mouseleave)="isHovered = false"
>
  <app-breadcrumb />
  <div id="right">
    <div id="status-icons">
      <app-profile-switch />
      <i
        faStyle="solid"
        [class.error]="!isOnline"
        [appIcon]="isOnline ? 'wifi' : 'wifi-slash'"
        [nz-tooltip]="wifiConnectionTooltip"
      >
        <ng-template #wifiConnectionTooltip>
          @switch (isOnline) {
            @case (true) {
              <ng-container i18n>Internetverbinding: OK</ng-container>
            }
            @case (false) {
              <ng-container i18n>Internetverbinding: Niet verbonden</ng-container>
            }
          }
        </ng-template>
      </i>
      <i
        faStyle="solid"
        [class.error]="hubState === 'Disconnected'"
        [class.intermediate]="hubState === 'Connecting' || hubState === 'Disconnecting' || hubState === 'Reconnecting'"
        [class.disabled]="hubState === 'Disconnected'"
        [appIcon]="hubState === 'Connected' || hubState === 'Disconnected' ? 'link' : 'link-slash'"
        nz-tooltip="Websockets: {{ hubState }}"
      >
      </i>
      <a (click)="openVersionInfo()">
        <i class="version-info" faStyle="regular" appIcon="circle-info" nz-popover></i>
      </a>
    </div>
    <!-- For future use, not supported in 4.5 yet. -->
    <!-- <app-universal-search></app-universal-search> -->
  </div>
</nz-header>

@if (versionInfoModalVisible()) {
  <nz-modal
    [nzVisible]="true"
    [nzCancelText]="null"
    (nzOnCancel)="versionInfoModalVisible.set(false)"
    (nzOnOk)="versionInfoModalVisible.set(false)"
  >
    <div *nzModalContent class="version-info-modal">
      <img src="./assets/images/logo.svg" width="100" height="100" />
      <p class="version-info-modal-title">FrontForce Emergency</p>
      <table>
        <tr class="master">
          <th>
            <strong>IP</strong>
          </th>
          <td>
            <span nz-typography nzCopyable [nzCopyTooltips]="null" nzContent="{{ info?.ip }}"></span>
          </td>
        </tr>
        <tr class="detail">
          <th>
            <strong i18n>Versie</strong>
          </th>
          <td>
            <span nz-typography nzCopyable [nzCopyTooltips]="null" nzContent="{{ info?.appVersion }}"></span>
          </td>
        </tr>
      </table>
    </div>
  </nz-modal>
}
